import { Link } from '@chakra-ui/next-js';
import { Box, Center, Image, Show, Text } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import { headerData } from '@utils/microsites/Data';
import { nanoid } from 'nanoid';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const GenILAPrograms = ({ sectionContent }) => {
  return (
    <Box
      mx="auto"
      w="100%"
      //h="100vh"
      maxW={"1061px"}
      top="0"
      bottom="0"
      left={0}
      right={0}
      //pb="500px"
      zIndex={9999}
      px={{ base: '16px', sm: 0 }}
    >
       <Text
            fontFamily="var(--FedraSansCondensedMedium), sans-serif"
            color="#fff"
            fontSize={{ md: '46px', base: '40px' }}
            lineHeight={{base:"129%", sm:"129%", md:"160%"}}
            textTransform="uppercase"
            as="h2"
            pb="20px"
          >
            {sectionContent[0]?.titleText}
        </Text>
      <Box
        width="100%"
        display="flex"
        flexWrap="wrap"
        mx="auto"
        maxW={{ base: 'none', xl: '1020px' }}
        alignItems="center"
        justifyContent="space-between"
        overflowY={{ base: 'auto', lg: 'none' }}
      >
        {headerData?.data?.map(data => {
         if(data?.link != "sadhguru-academy/gen-a-entrepreneurship-bootcamp" && data?.link != "sadhguru-academy/insight-indepth" && data?.link != "sadhguru-academy/harnessing-money-magic"){
          return (
            <Link
              key={nanoid()}
              href={`${config?.BASE_PATH}/${data?.link}`}
              onClick={() => {
                setShowPrograms(false);
              }}
              fontFamily="var(--FedraSansStd-book)"
              className="linkHover"
            >
              <Box
                padding={{
                  base: '10px 0px 0px 10px',
                  md: '20px 0px 0px 20px',
                }}
              >
                <Show above="md">
                  <Image
                    width={{ md: '83%', lg: '100%' }}
                    src={data.img}
                    alt={data.heading}
                  />
                </Show>
                <Box width="92px" display={{ base: 'flex', md: 'none' }}>
                  <Image
                    width={{ base: '100%' }}
                    src={data?.imgMbl}
                    alt={data.heading}
                  />
                </Box>
              </Box>
              <Box
                color="white"
                padding={{
                  lg: '30px 0px 0px 40px',
                  md: '30px 0px 0px 0px',
                  base: '15px 0px 0px 20px',
                }}
                marginLeft={data?.link == "sadhguru-academy/harnessing-money-magic" ? {md:"23px"} : ""}
                width={{ md: '135px', lg: '185px', base: '168px' }}
              >
                <Text fontSize="16px" fontWeight="semibold" className="link">
                  {data.heading}
                </Text>
                <Text fontSize="12px" color="#8686CF">
                  {data.subHeading}
                </Text>
              </Box>
              <Box
                width={{ base: '10%', md: '20%' }}
                display="flex"
                justifyContent="end"
              >
                <LazyLoadImageComponent
                  src="https://static.sadhguru.org/d/103645/1691490732-vector-26.svg"
                  alt="arrow"
                />
              </Box>
            </Link>
          );
            }
        })}
      </Box>{' '}
      <style jsx global>
        {`
          .linkHover:hover p.link {
            color: #f27123;
          }
          .linkHover {
            border-bottom: 1px solid #3d3d96;
            padding: 0 0 20px 0;
            display: flex;
            width: 46%;
            align-items: center;
          }
          .linkHover:last-child {
            border: none;
          }
          .linkHover:last-child,
          .linkHover:nth-child(5) {
            border: none;
          }
          .linkHover:hover {
            background: rgb(65 65 139 / 40%);
          }
          @media (max-width: 767px) {
            .linkHover {
              border-bottom: 1px solid#3d3d96;
              padding: 20px 0;
              display: flex;
              width: 100%;
              align-items: center;
            }
            .linkHover:last-child {
              border: none;
            }
            .linkHover:nth-child(5) {
              border-bottom: 1px solid#3d3d96;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default GenILAPrograms;
